export const ARTICLE_TYPES = {
  internal: 'internal',
  external: 'external',
};
